import React, { useState } from 'react';
import './pricing-faq.css';
import FAQemployer from '../../../assets/images/ic_client.png';
import FAQcandidate from '../../../assets/images/Ic_candidate.png';

const FAQ = ({ fromNavbar }) => {
  const [activeDefaultIndex, setActiveDefaultIndex] = useState(null);
  const [activeNavbarIndex, setActiveNavbarIndex] = useState(null);
  const [selectedFAQ, setSelectedFAQ] = useState('employer');
  const defaultFAQs = [
    { question: 'How I can upload loremipsum?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
    {
      question: 'How I know Startup details of loremipsum?',
      answer: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
      question: 'How I can check my applications?',
      answer:
        'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    {
      question: 'Is the Individual follow startup for loremipsum?',
      answer: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    },
    {
      question: 'Any startup directly message to Individual?',
      answer:
        'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    },
  ];

  const employerFAQs = [
    {
      heading: "About Leaderly",
      items: [
        {
          question: "1. What is Leaderly ?",
          answer: "Leaderly is a hiring platform that provides access to verified and assessed mid-level and senior-level candidates , helping employers find the right leadership talent efficiently.",
        },
        {
          question: "2. How is Leaderly different from traditional job portals ?",
          answer: "Unlike job portals that rely on self-reported resumes , Leaderly features pre-verified and assessed candidates , offering deeper insights into expertise , reporting structures , and key achievements.",
        },
        {
          question: "3. Who can use Leaderly ?",
          answer: "Leaderly is designed for HR leaders , recruiters , and hiring managers looking to hire mid and senior-level professionals across various industries.",
        },
        {
          question: "4. What industries and roles does Leaderly cover ?",
          answer: "Leaderly caters to a wide range of industries helping companies hire for <strong> mid-level to senior leadership roles</strong> across domains like production , R&D , HR , finance , operations , sales , and more.",
        },
      ],
    },
    {
      heading: "Candidate Profiles & Assessments",
      items: [
        {
          question: "5. How are candidates verified ?",
          answer: "Leaderly conducts thorough verification , including professional history validation , and expertise assessment before listing candidates on the platform.",
        },
        {
          question: "6. What kind of details are available in a candidate’s profile ?",
          answer: "Each profile includes verified work experience , expertise , reporting structures , key achievements , and detailed CTC breakdowns.",
        },
        {
          question: "7. How does Leaderly assess candidates ?",
          answer: "Leaderly evaluates candidates through structured assessments , reference checks , and AI-powered screening to ensure credibility and suitability for leadership roles.",
        },

      ],
    },
    {
      heading: "Using the Platform",
      items: [
        {
          question: "8. How can I search for candidates on Leaderly ?",
          answer: "Employers can filter candidates based on experience , skills , industry , leadership levels , expertise , and compensation to find the best match.",
        },
        {
          question: "9. Can I request additional information about a candidate ?",
          answer: "Yes , you can request more details or schedule an interaction with shortlisted candidates directly.",
        },
        {
          question: "10. Does Leaderly support direct communication with candidates ?",
          answer: "Yes , employers can connect with shortlisted candidates directly for discussions , interviews , or assessments.",
        },

      ],
    },
    {
      heading: "Pricing & Commitments",
      items: [
        {
          question: "11. Is there a cost to using Leaderly ?",
          answer: "Leaderly offers different pricing models based on hiring needs. Contact us for a tailored plan.",
        },
        {
          question: "12. Do I need to commit before exploring the platform ?",
          answer: "No , you can explore the platform , browse candidate profiles , and experience the demo before making any commitments.",
        },
        {
          question: "13. How do I get started ?",
          answer: "Simply sign up, define your hiring requirements , and start exploring pre-verified senior professionals immediately.",
        },

      ],
    },
  ];
  const candidateFAQs = [
    {
      heading: "About Leaderly",
      items: [
        {
          question: "1. What is Leaderly ?",
          answer: "Leaderly is a <strong>career platform for mid-level and senior professionals</strong> , connecting them with top organizations looking for verified and assessed leadership talent.",
        },
        {
          question: "2. How is Leaderly different from traditional job portals ?",
          answer: "Unlike traditional job portals , <strong>Leaderly verifies and assesses candidates</strong> , showcasing their expertise , leadership skills , and career achievements to top employers.",
        },
        {
          question: "3. What kind of roles are available on Leaderly ?",
          answer: "Leaderly focuses on <strong>mid and senior-level positions</strong> across various industries and functions such as <strong>production , R&D , procurement , supply chain , finance , operations , sales , marketing , and more</strong>.",
        },
      ],
    },
    {
      heading: "Candidate Verification & Assessment",
      items: [
        {
          question: "4. How does Leaderly verify candidates ?",
          answer: `Leaderly verifies candidates through :
          <ul><strong>
          <li>Employment history validation</li>
          <li>Reference Checks</li>
          <li>Assessment of expertise and leadership skills</li>
          </ul></strong>`,
        },
        {
          question: "5. What does my Leaderly profile include ?",
          answer: `Your profile highlights :
          <ul><strong>
          <li>Verified work experience & skills</li>
          <li>Reporting structures & leadership scope</li>
          <li>Key achievements & impact</li>
          <li>CTC breakdown for transparency with employers</li>
          </ul></strong>`,
        },
        {
          question: "6. Do I need to take an assessment to be on Leaderly ?",
          answer: "Yes , candidates may undergo <strong>structured assessments and validation</strong> to ensure their profiles reflect their true capabilities.",
        },
      ],
    },
    {
      heading: "Using Leaderly as a Candidate",
      items: [
        {
          question: "7. How can I create my profile on Leaderly ?",
          answer: "Simply <strong>sign up , fill in your professional details , and complete the verification process</strong> to be visible to top employers.",
        },
        {
          question: "8. Can employers contact me directly ?",
          answer: "Yes! Once your profile is verified , <strong>employers looking for leadership talent can connect with you directly</strong>.",
        },
        {
          question: "9. Will my job search remain confidential ?",
          answer: "Absolutely! <strong>Your profile remains private</strong> , and only verified employers can access it. You can also control <strong>who sees your profile</strong>.",
        },
      ],
    },
    {
      heading: "Opportunities & Benefits",
      items: [
        {
          question: "10. Is Leaderly free for candidates ?",
          answer: "Yes , <strong>Leaderly is completely free</strong> for candidates. You can create your profile , get verified , and connect with top employers at no cost.",
        },
        {
          question: "11. What are the benefits of joining Leaderly ?",
          answer: `
          <ul>
          <li><strong>Access exclusive leadership roles</strong> not available on traditional job portals</li>
          <li><strong>Connect directly with hiring managers & decision-makers</strong></li>
          <li><strong>Showcase a verified , credibility-backed profile</strong> to top companies</li>
          <li><strong>Receive personalized job matches based on your expertise</strong></li>
          </ul>`,
        },
        {
          question: "12. How do I get started ?",
          answer: "Just <strong>sign up , complete your profile , and get verified</strong> to start exploring top leadership opportunities.",
        },
      ],
    },
  ];


  const toggleDefaultFAQ = (index) => {
    setActiveDefaultIndex(activeDefaultIndex === index ? null : index);
  };

  const toggleNavbarFAQ = (index) => {
    setActiveNavbarIndex(activeNavbarIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      {fromNavbar ? (
        <>
          <div className="faq-user-container">
            <div className="faq-user-buttons">
              <button
                className={`faq-user-button-client ${selectedFAQ === 'employer' ? 'active' : ''}`}
                onClick={() => setSelectedFAQ('employer')}
              >
                <div className="faq-usericon-container">
                  <div className="faq-usericon-background">
                    <img src={FAQemployer} alt="Employer" className="faq-usericon-image" />
                  </div>
                </div>
                <p>For Employer</p>
              </button>

              <button
                className={`faq-user-button-candidate ${selectedFAQ === 'candidate' ? 'active' : ''}`}
                onClick={() => setSelectedFAQ('candidate')}
              >
                <div className="faq-usericon-container">
                  <div className="faq-usericon-background">
                    <img src={FAQcandidate} alt="Candidate" className="faq-usericon-image" />
                  </div>
                </div>
                <p>For Candidate</p>
              </button>
            </div>

          </div>

          <div className="additional-faq-container">
            <h2 className="faq-head">    {selectedFAQ === 'employer' ? 'Frequently Asked Questions - Employer' : 'Frequently Asked Questions - Candidate'}
            </h2>
            {(selectedFAQ === 'employer' ? employerFAQs : candidateFAQs).map((section, sectionIndex) => (
              <div key={sectionIndex}>
                <h4 className="faq-section-heading">{section.heading}</h4>
                {section.items.map((item, index) => (
                  <div className="faq-item" key={index}>
                    <div className="faq-question" onClick={() => toggleNavbarFAQ(`${sectionIndex}-${index}`)}>
                      {item.question}
                      <span className="faq-icon">{activeNavbarIndex === `${sectionIndex}-${index}` ? '-' : '+'}</span>
                    </div>
                    <div className={`faq-answer ${activeNavbarIndex === `${sectionIndex}-${index}` ? 'active' : ''}`}>
                      {activeNavbarIndex === `${sectionIndex}-${index}` && (
                        <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>

        </>
      ) : (
        <>
          <div className="additional-faq-container">
            <h2 className="faq-head">Frequently Asked Questions</h2>
            {defaultFAQs.map((item, index) => (
              <div className="faq-item" key={index}>
                <div className="faq-question" onClick={() => toggleDefaultFAQ(index)}>
                  {item.question}
                  <span className="faq-icon">{activeDefaultIndex === index ? '-' : '+'}</span>
                </div>
                <div className={`faq-answer ${activeDefaultIndex === index ? 'active' : ''}`}>
                  {activeDefaultIndex === index && <p>{item.answer}</p>}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default FAQ;
